import Experience from "../Experience";
import Environment from "./Environment";
import * as THREE from "three";
import Room from "./Room";
import Display from "./Display";
import Curtain from "./Curtain";
import EventEmitter from "../Utils/EventEmitter";
export default class World  {
    constructor() {

        this.experience = new Experience();
        this.scene = this.experience.scene;
        this.resources = this.experience.resources;
        this.environment = new Environment();
        this.room = new Room();
        this.curtain = new Curtain();
        
        this.display = new Display();

        
    }

    update(){
        this.curtain.update();
    }
}